import { useEffect, useState } from "react";
import axios from "axios";
import { API_BASE } from "../lib/api";

/**
 * Fetch admin-editable SEO settings for a given page key ("home" | "search").
 * Returns null while loading (caller should fall back to static SEO); once
 * loaded, returns the settings object. Uses a plain axios instance (no
 * credentials) so caching / CDN is friendlier.
 */
export function useDynamicSEO(pageKey) {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    if (!pageKey) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await axios.get(`${API_BASE}/api/seo/${pageKey}`, {
          timeout: 6000,
        });
        if (alive) setSettings(data);
      } catch {
        if (alive) setSettings(null);
      }
    })();
    return () => {
      alive = false;
    };
  }, [pageKey]);
  return settings;
}
